export const SongMaster = {
  SONG: "SONG",
  MASTER: "MASTER"
};
